import QueryString from 'query-string';
import { toastr } from 'react-redux-toastr';
import { push } from 'react-router-redux';
import { isErrorResponse } from '../../utils/error-handlers';
import { BASIC_POST_CONFIG, DEFAULT_GET_CONFIG } from '../../config/rest';
import {
  CLEAR_PRICING_PROFILE_MASSIVE_UPDATE,
  CLEAR_PRICING_PROFILE_MASSIVE_UPDATES,
  FLAG_GETTING_PRICING_PROFILE_MASSIVE_UPDATES,
  FLAG_PRICING_PROFILE_MASSIVE_UPDATE_ACTIVITY,
  GET_PRICING_PROFILE_MASSIVE_UPDATE,
  GET_PRICING_PROFILE_MASSIVE_UPDATES,
} from '../types';
import { PRICING_PROFILE_MASSIVE_UPDATE_ENPOINT } from '../../config/endpoints';
import { PRICING_PROFILE_MASSIVE_UPDATE_PATH } from '../../config/paths';

const flagGettingPricingProfileMassiveUpdates = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_GETTING_PRICING_PROFILE_MASSIVE_UPDATES,
    payload: flag,
  });

const flagPricingProfileMassiveUpdateActivity = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_PRICING_PROFILE_MASSIVE_UPDATE_ACTIVITY,
    payload: flag,
  });

const getPricingProfileMassiveUpdates =
  (tableFilters = null) =>
  async (dispatch) => {
    try {
      dispatch(flagGettingPricingProfileMassiveUpdates(true));

      const query = tableFilters || {};
      const url = `${PRICING_PROFILE_MASSIVE_UPDATE_ENPOINT}?${QueryString.stringify(
        query,
      )}`;

      const response = await fetch(url, { ...DEFAULT_GET_CONFIG });
      await isErrorResponse(response, null, dispatch);

      const pricingProfiles = await response.json();

      dispatch({
        type: GET_PRICING_PROFILE_MASSIVE_UPDATES,
        payload: pricingProfiles,
      });
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagGettingPricingProfileMassiveUpdates(false));
    }
  };

const clearPricingProfileMassiveUpdates = () => (dispatch) =>
  dispatch({
    type: CLEAR_PRICING_PROFILE_MASSIVE_UPDATES,
  });

const clearPricingProfileMassiveUpdate = () => (dispatch) =>
  dispatch({
    type: CLEAR_PRICING_PROFILE_MASSIVE_UPDATE,
  });

const getPricingProfileMassiveUpdate =
  async ({ pricingProfileMassiveUpdateId }) =>
  async (dispatch) => {
    try {
      dispatch(flagPricingProfileMassiveUpdateActivity(true));

      const url = `${PRICING_PROFILE_MASSIVE_UPDATE_ENPOINT}/${pricingProfileMassiveUpdateId}`;

      const response = await fetch(url, { ...DEFAULT_GET_CONFIG });

      await isErrorResponse(response, null, dispatch);

      const pricingProfileDateRange = await response.json();

      dispatch({
        type: GET_PRICING_PROFILE_MASSIVE_UPDATE,
        payload: pricingProfileDateRange,
      });
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagPricingProfileMassiveUpdateActivity(false));
    }
  };

const getPricingProfileMassiveUpdateTemplate =
  ({ corporate, startDate, endDate }) =>
  async (dispatch) => {
    try {
      dispatch(flagPricingProfileMassiveUpdateActivity(true));

      const query = {
        corporate,
        startDate,
        endDate,
      };

      const url = `${PRICING_PROFILE_MASSIVE_UPDATE_ENPOINT}/template?${QueryString.stringify(
        query,
      )}`;

      const response = await fetch(url, {
        ...DEFAULT_GET_CONFIG,
      });

      await isErrorResponse(response, null, dispatch);

      const blob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = downloadUrl;
      link.download = 'Pricing_profile_date_schedule_template.xlsx';
      document.body.appendChild(link);
      link.click();
      link.remove();

      window.URL.revokeObjectURL(downloadUrl);
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagPricingProfileMassiveUpdateActivity(false));
    }
  };

const postPricingProfileDateSchedule =
  ({ description, file, startDate, endDate, corporate }) =>
  async (dispatch) => {
    try {
      dispatch(flagPricingProfileMassiveUpdateActivity(true));

      const url = `${PRICING_PROFILE_MASSIVE_UPDATE_ENPOINT}/import-data`;

      const formData = new FormData();
      formData.append('file', file);
      formData.append('description', description || '');

      formData.append('startDate', startDate);
      formData.append('endDate', endDate);

      formData.append('corporate', corporate);

      const response = await fetch(url, {
        ...BASIC_POST_CONFIG,
        body: formData,
      });

      await isErrorResponse(response);

      const schedule = await response.json();

      dispatch(push(`${PRICING_PROFILE_MASSIVE_UPDATE_PATH}/${schedule.id}`));
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagPricingProfileMassiveUpdateActivity(false));
    }
  };

export {
  clearPricingProfileMassiveUpdate,
  clearPricingProfileMassiveUpdates,
  getPricingProfileMassiveUpdate,
  flagGettingPricingProfileMassiveUpdates,
  flagPricingProfileMassiveUpdateActivity,
  getPricingProfileMassiveUpdates,
  getPricingProfileMassiveUpdateTemplate,
  postPricingProfileDateSchedule,
};
